// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d209940b","667":"12d233a8","977":"61479c04"}[chunkId] + ".chunk.js";
};